<div class="component-wrapper container">
  <div class="row text-md-center">
    <div class="title-2 col-12">
      Awesome! Your order has been placed.
    </div>
  </div>

  <div class="row mt-2 mt-lg-3 mt-xl-2 text-md-center">
    <div class="content-2 col-12">
      We still need some details to submit your LLC. Now that your business is almost official, it’s time to think about protecting what’s important. We’ve made it easy with these special offers.
    </div>
  </div>

  <div class="row mt-9 mt-md-5 glo-close-card-row flex-column justify-content-center align-content-center flex-md-row-reverse flex-md-wrap">
    <div *ngFor="let item of itemList; index as i;" 
      [class.glo-badge]="i === 0"
      [class.mb-0]="i === 3"
      [class.glo-selected]="i === 0"
      class="card glo-close-card my-2 col-12 col-lg-4">
			<div>
				<p *ngIf="i === 0" class="card-badge caption-3">BUY BOTH</p>
				<div class="glo-header d-table w-100">
					<div class="d-table-cell align-middle w-100">
						<h2 class="highlight-2 m-0">{{item.title}}</h2>
						<p class="glo-subtitle highlight-2 m-0">${{item.price}}<span class="glo-caption caption-1">&nbsp;(Usually ${{item.usuallyPrice}})</span></p>
					</div>
					<div class="d-table-cell align-top pl-4">
            <ng-container *ngTemplateOutlet="icon; context: {iconId: item.id}"></ng-container>
          </div>
        </div>
        
        <div class="glo-section d-table w-100">
          <!-- start mobile only section-->
          <div class="d-table-cell d-md-none align-middle w-100 glo-size-18 pr-2">
            <a [href]="'#collapse-' + i"
            [attr.aria-controls]="'collapse-' + i" 
            aria-expanded="false" 
            class="glo-toggle glo-link-action-plain collapsed text-decoration-none" 
            data-toggle="collapse" 
            role="button">
              <span class="glo-inline-a">View</span>
              <span aria-hidden="true" class="glo-inline-b">Hide</span> 
              <span>&nbsp;features</span>
              <span class="glo-icon icon-chevron">
                <svg viewBox="0 0 15 9" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                  <title>E2735030-6FB4-4534-BAF6-7E903C5BA093</title>
                  <g id="LLC-Q1---Mobile" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" stroke-linecap="round">
                      <g id="m_LLC-Q1_17.1_LWT-TM_selected" transform="translate(-171.000000, -616.000000)" stroke="#0066FF" stroke-width="3">
                          <g id="Group-35" transform="translate(20.000000, 420.000000)">
                              <g id="Group-Copy-5" transform="translate(24.000000, 54.000000)">
                                  <g id="More-info" transform="translate(0.000000, 132.000000)">
                                      <g id="UI-Support-/-General-/-Picture" transform="translate(128.000000, 11.000000)">
                                          <polyline id="Arrow" transform="translate(6.000000, 3.000000) rotate(-270.000000) translate(-6.000000, -3.000000) " points="3.5 -2.5 8.5 2.99960717 3.5 8.5"></polyline>
                                      </g>
                                  </g>
                              </g>
                          </g>
                      </g>
                  </g>
                </svg>
              </span>
            </a>
          </div>
          <!-- end mobile only section-->
          
          <div class="d-table-cell align-middle">
            <span class="btn-group" role="group">
              <input (click)="onClickItem(item.id)" [id]="item.id" name="express-offer" type="radio" [value]="item.id" [checked]="item.id === packageSelected" > 
              <label class="btn btn-outline-action" [for]="item.id">
                <span class="glo-btn-text">Select</span> 
                <span aria-hidden="true" class="glo-btn-icon">
                  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <polyline fill="none" points="2 12 9 18 21 4" stroke="currentColor" stroke-width="6"></polyline>
                  </svg>
                </span>
              </label>
            </span>
          </div>
        </div>

				<div class="glo-section content-3 collapse d-md-block" [id]="'collapse-' + i">
          <div class="glo-card-border"></div>
					<ul class="glo-list-check">
            <li 
            *ngFor="let description of item.descriptionList; index as i2"
            [class.mt-4]="i2 > 0"
            [innerHTML]="description">
          </li>
					</ul>
				</div>
			</div>
		</div>
  </div>
  
  <div class="row">
    <div class="col-12 text-center mt-5 d-none d-md-block">
      <button 
        id="btn-accept"
        (click)="!packageSelected || paidOrPaying ? true : checkout()" 
        [class.btn-disabled]="!packageSelected"
        [class.glo-btn-loading]="paidOrPaying"
        type="button" 
        class="btn btn-action btn-lg">
        <span *ngIf="!paidOrPaying">Agree and pay</span>
        <span class="glo-loading-dots" *ngIf="paidOrPaying">
          Processing
          <span>.</span>
          <span>.</span>
          <span>.</span>
        </span>
      </button>
    </div>
    <div *ngIf="!paidOrPaying" class="col-12 text-center mt-9">
      <a id="btn-decline" href="javascript:void(0)" (click)="continue()" class="glo-link-action text-decoration-none">No thanks</a>
    </div>
  </div>
</div>

<div 
  class="position-fixed d-md-none position-fixed w-100 bottom-18px glo-pointer-events-none"
  [class.d-none]="!packageSelected"
  >
  <div class="container">
    <div class="row">
      <div class="col-12">
        <button 
          id="btn-accept-1"
          (click)="!packageSelected || paidOrPaying ? true : checkout()" 
          [class.btn-disabled]="!packageSelected"
          [class.glo-btn-loading]="paidOrPaying"
          type="button" 
          class="btn btn-action w-100 glo-pointer-events-initial">
          <span *ngIf="!paidOrPaying">Agree and pay</span>
          <span class="glo-loading-dots" *ngIf="paidOrPaying">
            Processing
            <span>.</span>
            <span>.</span>
            <span>.</span>
          </span>
        </button>
      </div>
    </div>
  </div>  
</div>



<ng-template #icon let-iconId="iconId">
  <ng-container *ngIf="iconId === 'express-lwt'">
    <svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
      <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">      
        <rect x="0" y="0" width="48" height="48"></rect>
        <g transform="translate(6.000000, 2.000000)">
            <g transform="translate(12.000000, 20.000000)" fill="#000000">
                <path d="M15.5970821,1.52047285 C16.3903723,2.43363799 17.5291844,2.98365252 18.7420369,3.0330128 C21.4215949,3.14936202 23.3819031,5.60679872 22.8988775,8.2475736 C22.6915643,9.35982519 22.9234479,10.5058612 23.5371973,11.4506242 L23.674539,11.649907 C25.2575936,13.8182335 24.5559725,16.8820965 22.1902049,18.1478351 C21.1219075,18.7225297 20.3356688,19.7097353 20.014827,20.880279 C19.3061544,23.4681679 16.4714642,24.832627 14.006976,23.771381 C12.9671195,23.3238478 11.7982681,23.2940123 10.7412122,23.6818744 L10.5164992,23.771381 C8.05201102,24.832627 5.21732077,23.4681679 4.5086482,20.880279 C4.19133213,19.7097353 3.40156768,18.7225297 2.33327024,18.1478351 C0.0314422927,16.9163057 -0.69163968,13.9825343 0.725845353,11.8276266 L0.848936163,11.649907 C1.56466019,10.669753 1.84671893,9.43927174 1.62812341,8.2475736 C1.1415721,5.60679872 3.10188028,3.14936202 5.78496396,3.0330128 C6.99429078,2.98365252 8.1331029,2.43363799 8.92991882,1.52047285 C10.6892602,-0.506824283 13.834215,-0.506824283 15.5970821,1.52047285 Z M12.2607532,5.39950566 C8.57988679,5.39950566 5.5971157,8.38580248 5.5971157,12.0666689 C5.5971157,15.7475354 8.57988679,18.7338322 12.2607532,18.7338322 C15.9416197,18.7338322 18.9279165,15.7475354 18.9279165,12.0666689 C18.9279165,8.38580248 15.9416197,5.39950566 12.2607532,5.39950566 Z" ></path>
            </g>
            <polyline stroke="#000000" stroke-width="4" stroke-linecap="round" points="8.83908995 44 0 44 0 0 26 0 36 10 36 17.8422619"></polyline>
        </g>        
      </g>
  </svg>
  </ng-container>

  <ng-container *ngIf="iconId === 'express-tms'">
    <svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
      <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">      
        <rect x="0" y="0" width="48" height="48"></rect>
        <g transform="translate(2.000000, 2.000000)" stroke="#000000" stroke-linecap="round" stroke-width="4">
            <path d="M40.1121236,34.4915833 C42.563955,30.9433008 44,26.6393535 44,22 C44,9.8497355 34.1502645,0 22,0 C9.8497355,0 0,9.8497355 0,22 C0,34.1502645 9.8497355,44 22,44 C26.6389883,44 30.9426231,42.5641811 34.4907452,40.1127026 M10,17 L18,17 M14,17 L14,28 M34,28 L34,17 L33.5,17 L28.4,25 L23.5,17 L23,17 L23,28"></path>
        </g>
      </g>
  </svg>
  </ng-container>

  <ng-container *ngIf="iconId === 'express-both'">
    <svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
      <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">    
        <rect x="0" y="0" width="48" height="48"></rect>
        <g transform="translate(2.000000, 2.000000)" stroke="#000000" stroke-linecap="round" stroke-width="4">
          <path d="M6,11.4183831 L6,0 L32,0 L42,10 L42,44 L34.0594881,44 M17.8661519,44 C27.7333551,44 35.7323037,36.0010514 35.7323037,26.1338481 C35.7323037,16.2666449 27.7333551,8.26769629 17.8661519,8.26769629 C7.99894865,8.26769629 2.84217094e-14,16.2666449 2.84217094e-14,26.1338481 C2.84217094e-14,36.0010514 7.99894865,44 17.8661519,44 Z M10.4963642,21.8135683 L10.4963642,30.9120716 M27.9096587,30.9120716 L27.9096587,21.8135683 L27.6794697,21.8135683 L23.1092584,28.4306616 L18.7116888,21.8135683 L18.4803008,21.8135683 L18.4803008,30.9120716 M6.94794794,21.8135683 L14.0447805,21.8135683"></path>        
        </g>
      </g>
  </svg>
  </ng-container>
</ng-template>

